const INITIAL_STATE = {
  open: false,
  fileSend: false,
};

const sideMenuReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case 'OPEN_SIDE_MENU':
      return {
        ...state,
        open: action.payload,
      };
    case 'SET_FILE_SEND':
      return {
        ...state,
        fileSend: action.payload,
      };
    default:
      return state;
  }
};
export default sideMenuReducer;
